import { type ReactNode, useEffect } from 'react';
import { ErrorBoundary } from './ErrorBoundary';
import { authAdapter } from '@services/auth';
import { useAuthStore } from '@stores/authStore';
import { ToastContainer } from '@components/Toast';
import { createLogger } from '@utils/logger';

const log = createLogger('Providers');

interface Props {
  children: ReactNode;
}

export function Providers({ children }: Props) {
  useEffect(() => {
    // 启动时恢复持久化登录态
    let initFailed = false;
    void authAdapter
      .init()
      .catch((err) => {
        initFailed = true;
        log.warn('Auth initialization failed', err);
      })
      .finally(() => {
        const { setAuth, setInitialized } = useAuthStore.getState();
        const settled = initFailed ? true : (authAdapter.isAuthSettled?.() ?? true);
        setAuth(authAdapter.getUser(), authAdapter.getToken(), settled);
        setInitialized(settled);
      });

    return authAdapter.onAuthChange((user) => {
      const { setAuth, clearAuth } = useAuthStore.getState();
      if (user) {
        setAuth(user, authAdapter.getToken());
      } else {
        clearAuth();
      }
    });
  }, []);

  return (
    <ErrorBoundary>
      <div className="text-foreground min-h-screen">{children}</div>
      <ToastContainer />
    </ErrorBoundary>
  );
}
